import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import SectionContainer from "../../../components/sectionContainer/sectionContainer";
import MonthToDate from "./smartComponents/monthToDate";
import PreviousYearMonthToDate from "./smartComponents/previousYearMonthToDate";
import { actionCreators } from "./redux/sagas/revenueDetails/revenueDetails";
import MonthToDateChange from "./smartComponents/monthToDateChange";
import YearToDateChange from "./smartComponents/yearToDateChange";
import RevenueByType from "./smartComponents/revenueByType";
import YearToDate from "./smartComponents/yearToDate";
import YearToDateYearAgo from "./smartComponents/yearToDateYearAgo";
import RevenuePieChart from "./smartComponents/revenuePieChart";
import { isModuleActive } from "../../../utils/modules";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import NoData from "../../../components/noData/noData";
import { configuratorStore } from "../dashboardConfigurator/dashboard";
import { configuratorMonthSwitcherStore } from "../monthSwitcherModule/monthSwitcher";
import LearnMore from "../../../components/learnMore/learnMore";
import Forecast from "../revenueDetailsModule/smartComponents/forecast";

export class RevenueDetailsModule extends React.Component {
  state = {
    initRequest: false
  };

  componentDidMount() {
    if (isModuleActive(this.props.currentUser.dashboardPreferences, "Revenue Details")) {
      this.props.fetchCurrentUser({ user: this.props.currentUser });
      this.setState({
        initRequest: true
      });
    }
    // Dashboard configurator store
    configuratorStore.subscribe(() => {
      const state = configuratorStore.getState();
      if (isModuleActive(state.dashboardConfigurator.preferences, "Revenue Details") & !this.state.initRequest) {
        const { monthSwitcher } = configuratorMonthSwitcherStore.getState();

        this.props.fetchCurrentUser({ user: this.props.currentUser, date: monthSwitcher.date });
        this.setState({
          initRequest: true
        });
      }
    });

    // Month switcher store
    let previousDate;
    configuratorMonthSwitcherStore.subscribe(() => {
      if (this.state.initRequest) {
        const currentDate = configuratorMonthSwitcherStore.getState().monthSwitcher.date;

        if (currentDate !== previousDate) {
          previousDate = currentDate;
          this.props.updateAllData(currentDate);
        }
      }
    });
  }

  handleToggle = () => {
    this.setState({ active: !this.state.active });
  };

  doesPieChartHaveData = () => {
    if (this.props.revenuesForPieChart.length === 1 && this.props.revenuesForPieChart[0]) {
      const [firstElement] = this.props.revenuesForPieChart;
      return firstElement[1] !== 0;
    }

    return !!this.props.revenuesForPieChart.length;
  };

  content() {
    return (
      <div>
        <div className="section-group">
          <span className="width-50">
            <SectionContainer title="Month To Date">
              <MonthToDate />
              <MonthToDateChange />
            </SectionContainer>
          </span>
          <span className="width-50">
            <SectionContainer title="Month to Date this time Last Year">
              <PreviousYearMonthToDate />
            </SectionContainer>
          </span>
          <SectionContainer title="Revenue By Category MTD" customStyles="pie-chart">
            {this.doesPieChartHaveData() ? <RevenuePieChart isLegendTooltip={true} /> : <NoData />}
          </SectionContainer>
        </div>
        {this.props.sourceType === "clubready" ? (
          <div className="section-group">
            <span className="width-50">
            <SectionContainer
                title="Forecast"
                toolTip={this.props.forecastTooltip}
                isToolTipHtml
                toolTipId="revenueDetailsForecast"
            >
              <Forecast />
              </SectionContainer>
            </span>
            <span className="width-50">
              <SectionContainer title="Year to Date">
                <YearToDate />
                <YearToDateChange />
              </SectionContainer>
            </span>
            <SectionContainer title="">{this.props.isUpdating ? <LoadingAnimation /> : <RevenueByType />}</SectionContainer>
          </div>
        ) : (
        <div className="section-group">
          <span className="width-50">
            <SectionContainer title="Year to Date">
              <YearToDate />
              <YearToDateChange />
            </SectionContainer>
          </span>
          <span className="width-50">
            <SectionContainer title="Year to Date this time Last Year">
              <YearToDateYearAgo />
            </SectionContainer>
          </span>
          <SectionContainer title="">{this.props.isUpdating ? <LoadingAnimation /> : <RevenueByType />}</SectionContainer>
        </div>
        )}
      </div>
    );
  }

  render() {
    const {learnMoreId, title, content} = this.props.learnMore
    return (
      <SectionToggle
        title="Revenue Breakdown"
        learnMore={<LearnMore learnMoreId={learnMoreId} title={title} content={content} html/>}
        customClass="revenueDetailsWidget"
        isLoading={this.props.isLoading}
        content={this.content()}
      />
    );
  }
}

export default connect(
  state => ({
    isLoading: state.revenueDetails.isLoading,
    userParams: state.revenueDetails.currentUser,
    isUpdating: state.revenueDetails.isUpdating,
    revenuesForPieChart: state.revenueDetails.revenuesForPieChart,
    forecastTooltip: state.revenueDetails.forecastTooltip,
    sourceType: state.revenueDetails.currentUser.sourceType,
  }),
  {
    fetchCurrentUser: actionCreators.fetchCurrentUser,
    updateAllData: actionCreators.updateAllData
  }
)(RevenueDetailsModule);

RevenueDetailsModule.propTypes = {
  fetchCurrentUser: PropTypes.func.isRequired,
  updateAllData: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  currentUser: PropTypes.object,
  revenuesForPieChart: PropTypes.array,
  isUpdating: PropTypes.bool,
  learnMore: PropTypes.objectOf(PropTypes.string),
  forecastTooltip: PropTypes.string,
  sourceType: PropTypes.string
};
